import { COMPANY_INFO } from '../data/company';
import {
  LegalNav,
  LegalPageBody,
  LegalPageHero,
  LegalPanel,
  LegalSection,
  ReviewNotice,
  lastUpdated,
} from '../components/common/LegalPageShell';
import Seo from '../components/common/Seo';
import { routeMeta } from '../routeMeta';

const sections = [
  { id: 'about-this-site', label: 'About this site' },
  { id: 'informational-content', label: 'Informational content' },
  { id: 'quotes-and-enquiries', label: 'Quotes and enquiries' },
  { id: 'intellectual-property', label: 'Intellectual property' },
  { id: 'acceptable-use', label: 'Acceptable use' },
  { id: 'third-party-links', label: 'Third-party links' },
  { id: 'liability', label: 'Liability' },
  { id: 'law', label: 'Law and jurisdiction' },
  { id: 'contact', label: 'Contact' },
];

const TermsOfServicePage = () => {
  const primaryEmail = COMPANY_INFO.contact.email?.[0] || 'info@leiongroup.com';

  return (
    <div data-testid="terms-of-service-page">
      <Seo {...routeMeta['/terms-of-service']} path="/terms-of-service" />
      <LegalPageHero
        title="Terms of Service"
        currentPage="Terms of Service"
        description="Terms for using LEION Engineering's informational manufacturer website and enquiry workflow."
        meta={[
          ['Updated', lastUpdated],
          ['Jurisdiction', 'Gurgaon'],
        ]}
      />

      <LegalPageBody aside={<LegalNav sections={sections} />}>
        <ReviewNotice />
        <LegalPanel>
          <LegalSection id="about-this-site" title="About This Site">
            <p>
              This website is operated by {COMPANY_INFO.name}. It provides information about LEION Engineering products, services, support, and enquiry options.
            </p>
          </LegalSection>

          <LegalSection id="informational-content" title="Informational Content">
            <p>
              The content on this site is provided for general product and company information. Product specifications, capacities, certifications, installation timelines, warranty terms, and service commitments are indicative and may change.
            </p>
            <p>
              Visitors should confirm current product details directly with LEION Engineering before making purchase, installation, or operational decisions.
            </p>
          </LegalSection>

          <LegalSection id="quotes-and-enquiries" title="Quotes And Enquiries">
            <p>
              Nothing on this website is a binding offer. Quotations, commercial terms, delivery timelines, warranty coverage, and project commitments are issued separately by LEION Engineering.
            </p>
            <p>
              Submitting an enquiry does not create a contract or guarantee product availability.
            </p>
          </LegalSection>

          <LegalSection id="intellectual-property" title="Intellectual Property">
            <p>
              Site content, LEION Engineering branding, logos, product imagery, text, design elements, and other materials belong to LEION Engineering or are used by LEION Engineering for this site.
            </p>
            <p>
              Visitors may not copy, reproduce, modify, or commercially reuse site content without permission from LEION Engineering.
            </p>
          </LegalSection>

          <LegalSection id="acceptable-use" title="Acceptable Use">
            <p>
              Visitors must not misuse the website, interfere with its operation, attempt unauthorised access, submit false or misleading enquiries, or use the site in a way that could damage LEION Engineering or other users.
            </p>
          </LegalSection>

          <LegalSection id="third-party-links" title="Third-Party Links">
            <p>
              The site may include third-party links or embeds, including map and font services. LEION Engineering is not responsible for third-party websites, services, or their content.
            </p>
          </LegalSection>

          <LegalSection id="liability" title="Limitation Of Liability">
            <p>
              To the extent permitted by law, LEION Engineering is not liable for loss or damage arising from use of this website, reliance on informational website content, website unavailability, or third-party links and services.
            </p>
          </LegalSection>

          <LegalSection id="law" title="Governing Law">
            <p>
              These terms are governed by the laws of India. Courts in Gurgaon, Haryana, India will have jurisdiction, unless applicable law requires otherwise.
            </p>
          </LegalSection>

          <LegalSection id="contact" title="Contact">
            <p>
              Questions about these terms can be sent to <a href={`mailto:${primaryEmail}`} className="font-semibold text-[#93C5FD] hover:text-white">{primaryEmail}</a>.
            </p>
          </LegalSection>
        </LegalPanel>
      </LegalPageBody>
    </div>
  );
};

export default TermsOfServicePage;
